import React from 'react';
type StarsProps = {
  count?: number;
  size?: number;
  className?: string;
};
export function Stars({
  count = 5,
  size = 14,
  className = ''
}: StarsProps) {
  return <div className={`flex items-center gap-0.5 ${className}`} role="img" aria-label={`${count} de 5 estrellas`} data-id="element-145" data-mp="3kq4wcumwd5wm">
      {Array.from({
      length: 5
    }).map((_, i) => <svg key={i} aria-hidden="true" width={size} height={size} viewBox="0 0 24 24" fill={i < count ? '#D4AF37' : 'none'} stroke={i < count ? '#D4AF37' : 'rgba(245,240,232,0.35)'} strokeWidth="1.5" data-id="element-146" data-mp="3pqsx480xh141" data-mpi={i}>
          <path d="M12 2.5l2.9 5.9 6.6.9-4.8 4.6 1.2 6.5L12 17.3l-5.9 3.1 1.2-6.5L2.5 9.3l6.6-.9L12 2.5z" data-id="element-147" data-mp="3g6u2asah96w" />
        </svg>)}
    </div>;
}